<template>
  <v-dialog v-model="open" persistent max-width="720px">
    <v-card>
      <form @submit.prevent="!isProcessing ? onSubmit() : null">
        <v-card-title>
          <span class="headline">Edycja noty obciążeniowej</span>
        </v-card-title>
        <v-card-text>
          <v-container class="pt-0" grid-list-md>
            <v-layout wrap v-if="loaded">

              <v-flex xs12 sm6>
                <v-text-field
                  label="Nr noty"
                  v-model="formData.number"
                  browser-autocomplete="off"
                  readonly
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field
                  label="Data wystawienia"
                  v-model="formData.issued_at"
                  readonly
                  browser-autocomplete="off"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 class="display-flex align-items-center justify-content-between">
                <div class="subheading mb-1">Odbiorca</div>
                <v-btn small color="#555474" dark class="ma-0"
                       :loading="gusLoading"
                       @click="fetchFromGus">
                  <v-icon size="14px" class="mr-1">fas fa-cloud-download-alt</v-icon>
                  Pobierz z GUS
                </v-btn>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field label="Firma" v-model="formData.recipient_company_name" browser-autocomplete="off"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field label="NIP" v-model="formData.recipient_nip"
                              v-validate="'digits:10'" data-vv-name="NIP"
                              :error-messages="errors.collect('NIP')"
                              browser-autocomplete="off"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field label="PESEL" v-model="formData.recipient_pesel"
                              v-validate="'digits:11'" data-vv-name="PESEL"
                              :error-messages="errors.collect('PESEL')"
                              browser-autocomplete="off"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field label="Imię" v-model="formData.recipient_first_name" browser-autocomplete="off"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-text-field label="Nazwisko" v-model="formData.recipient_last_name" browser-autocomplete="off"></v-text-field>
              </v-flex>
              <v-flex xs12 sm8>
                <v-text-field label="Ulica" v-model="formData.recipient_street" browser-autocomplete="off"></v-text-field>
              </v-flex>
              <v-flex xs6 sm2>
                <v-text-field label="Nr budynku" v-model="formData.recipient_building_no" browser-autocomplete="off"></v-text-field>
              </v-flex>
              <v-flex xs6 sm2>
                <v-text-field label="Nr lokalu" v-model="formData.recipient_flat_no" browser-autocomplete="off"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4>
                <v-text-field label="Kod pocztowy" v-model="formData.recipient_postal_code" browser-autocomplete="off"></v-text-field>
              </v-flex>
              <v-flex xs12 sm8>
                <v-text-field label="Miasto" v-model="formData.recipient_city" browser-autocomplete="off"></v-text-field>
              </v-flex>

              <v-flex xs12>
                <div class="subheading mb-1">Płatność</div>
              </v-flex>

              <v-flex xs12 sm6>
                <v-autocomplete
                  :items="meta.payment_methods"
                  label="Metoda płatności"
                  v-model="formData.payment_method"
                  item-text="label"
                  item-value="value"
                  v-validate="'required'"
                  data-vv-name="metoda płatności"
                  :error-messages="errors.collect('metoda płatności')"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12 sm6 v-if="selectedMethodHasTerm">
                <v-autocomplete
                  :items="meta.payment_terms"
                  label="Termin płatności (dni)"
                  v-model="formData.payment_term_days"
                  item-text="label"
                  item-value="value"
                  v-validate="'required'"
                  data-vv-name="termin płatności"
                  :error-messages="errors.collect('termin płatności')"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs12>
                <div class="subheading mb-1">Vouchery</div>
              </v-flex>

              <v-flex xs12>
                <v-autocomplete
                  :items="allVouchers"
                  v-model="formData.voucher_ids"
                  label="Wybierz vouchery"
                  item-text="voucher_number"
                  item-value="id"
                  multiple
                  chips
                  deletable-chips
                  :filter="() => true"
                  :search-input.sync="voucherSearch"
                  :error-messages="errors.collect('vouchers')"
                  @input="clearVoucherError"
                  browser-autocomplete="off"
                  no-data-text="Wpisz numer vouchera aby wyszukać"
                >
                  <template slot="item" slot-scope="{ item }">
                    <v-list-tile-content>
                      <v-list-tile-title>
                        #{{ item.voucher_number }} — PLN {{ item.price }}
                        <span v-if="item.service_type"> — {{ item.service_type }}</span>
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat @click="$router.push({ name: 'DebitNotes' })">Anuluj</v-btn>
          <v-btn color="blue darken-1" flat :disabled="isProcessing" type="submit">Zapisz</v-btn>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions } from 'vuex';
  import { clearEmptyFields } from '../../helpers/clearEmptyFields';

  export default {
    name: 'EditDebitNote',
    data() {
      return {
        open: true,
        loaded: false,
        isProcessing: false,
        gusLoading: false,
        voucherSearch: null,
        voucherSearchTimeout: null,
        availableVouchers: [],
        currentVouchers: [],
        meta: { payment_methods: [], payment_terms: [] },
        formData: { voucher_ids: [] },
      };
    },
    computed: {
      allVouchers() {
        const ids = this.currentVouchers.map(v => v.id);
        const extra = this.availableVouchers.filter(v => !ids.includes(v.id));
        return [...this.currentVouchers, ...extra];
      },
      selectedMethodHasTerm() {
        const method = (this.meta.payment_methods || [])
          .find(m => m.value === this.formData.payment_method);
        return !!(method && method.has_term);
      },
    },
    watch: {
      voucherSearch(val) {
        this.onVoucherSearch(val);
      },
      selectedMethodHasTerm(hasTerm) {
        // metoda bez odroczonego terminu (np. gotówka) nie ma terminu płatności
        if (!hasTerm) {
          this.formData.payment_term_days = null;
        }
      },
    },
    mounted() {
      const noteId = this.$route.params.noteId;
      Promise.all([
        this.fetchNoteDetails(noteId),
        this.fetchMeta({}),
      ]).then(([note, meta]) => {
        this.meta = meta;
        this.currentVouchers = note.vouchers || [];
        this.loadAvailableVouchers('');
        const r = note.recipient || {};
        const p = note.payment || {};
        this.formData = {
          id: note.id,
          number: note.number,
          issued_at: note.issued_at ? note.issued_at.substr(0, 10) : null,
          recipient_company_name: r.company_name,
          recipient_nip: r.nip,
          recipient_pesel: r.pesel,
          recipient_first_name: r.first_name,
          recipient_last_name: r.last_name,
          recipient_street: r.street,
          recipient_building_no: r.building_no,
          recipient_flat_no: r.flat_no,
          recipient_postal_code: r.postal_code,
          recipient_city: r.city,
          payment_method: p.method,
          payment_term_days: p.term_days,
          voucher_ids: this.currentVouchers.map(v => v.id),
        };
        this.loaded = true;
      });
    },
    methods: {
      ...mapActions('DebitNoteStore', ['fetchNoteDetails', 'fetchMeta', 'fetchAvailableVouchers', 'updateNote']),
      ...mapActions('GusStore', ['searchCompany']),
      async fetchFromGus() {
        const nip = (this.formData.recipient_nip || '').replace(/[^0-9]/g, '');
        if (nip.length !== 10) {
          this.$validator.errors.add({ field: 'NIP', msg: 'Podaj poprawny NIP (10 cyfr).' });
          return;
        }
        this.gusLoading = true;
        try {
          const company = await this.searchCompany({ nip });
          this.$validator.errors.remove('NIP');
          this.applyGusCompany(company);
        } catch (e) {
          const msg = (e && e.response && e.response.data && e.response.data.message)
            ? e.response.data.message
            : 'Nie znaleziono podmiotu w GUS. Sprawdź poprawność NIP.';
          this.$validator.errors.add({ field: 'NIP', msg: msg });
        } finally {
          this.gusLoading = false;
        }
      },
      applyGusCompany(company) {
        const address = company.address || {};
        this.formData = {
          ...this.formData,
          recipient_company_name: company.name,
          recipient_nip: company.nip,
          recipient_street: address.street,
          recipient_building_no: address.building_number,
          recipient_flat_no: address.flat_number,
          recipient_postal_code: address.postal_code,
          recipient_city: address.city || address.postal_city,
        };
      },
      loadAvailableVouchers(search) {
        return this.fetchAvailableVouchers({ search: search || '' })
          .then((response) => {
            const results = response.data || response;
            const currentIds = this.currentVouchers.map(v => v.id);
            this.availableVouchers = results.filter(v => !currentIds.includes(v.id));
          });
      },
      onVoucherSearch(val) {
        clearTimeout(this.voucherSearchTimeout);
        this.voucherSearchTimeout = setTimeout(() => {
          this.loadAvailableVouchers(val || '');
        }, 300);
      },
      validateRecipient() {
        // odbiorca: wymagany NIP albo (imię i nazwisko) — jak w UpdateDebitNoteRequest
        const hasNip = (this.formData.recipient_nip || '').replace(/\D/g, '').length === 10;
        const hasName = !!(this.formData.recipient_first_name && this.formData.recipient_last_name);
        if (!hasNip && !hasName) {
          this.$validator.errors.add({
            field: 'NIP',
            msg: 'Podaj NIP albo imię i nazwisko odbiorcy.',
          });
          return false;
        }
        return true;
      },
      validateVouchers() {
        if (!this.formData.voucher_ids || !this.formData.voucher_ids.length) {
          this.$validator.errors.add({ field: 'vouchers', msg: 'Dodaj przynajmniej jeden voucher.' });
          return false;
        }
        return true;
      },
      clearVoucherError() {
        this.$validator.errors.remove('vouchers');
      },
      onSubmit() {
        this.$validator.validateAll()
          .then((isValid) => {
            const recipientValid = this.validateRecipient();
            const vouchersValid = this.validateVouchers();
            if (isValid && recipientValid && vouchersValid) {
              this.isProcessing = true;
              const formData = clearEmptyFields(Object.assign({}, this.formData));
              this.updateNote(formData)
                .then(() => {
                  this.isProcessing = false;
                  this.$router.push({ name: 'DebitNotes' });
                }, () => {
                  this.isProcessing = false;
                });
            }
          });
      },
    },
  };
</script>
